import type { NavigationContent } from "../types/content";
import leftLogoTag from "../assets/logos/left_logo_tag.png";

export const navigationContent: NavigationContent = {
  logo: leftLogoTag,
  menuItems: [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Training", path: "/training" },
    { label: "Insights", path: "/insights" },
    { label: "Resources", path: "/resources" },
  ],
  ctaButton: {
    text: "Book a meeting",
    url: "https://calendar.proton.me/bookings#GT-Th3lMCUvSdkTZP-GTcaxqPwWn8VJHP0MWzoiqkXk=",
  },
};
